import React, { useState, useEffect } from 'react';
import { testUrls } from './testUrls';

const TestUrls = () => {
  const baseUrls = {
    'shop.rewe.de': 'https://shop.rewe.de',
    'rewe.de/shop': 'https://rewe.de/shop',
    'www.rewe.de/shop': 'https://www.rewe.de/shop',
    'shop.pre.rd-ecom-test.com': 'https://shop.pre.rd-ecom-test.com',
    'pre.rd-ecom-test.com/shop': 'https://www.pre.rd-ecom-test.com/shop',
  };

  const [selectedBase, setSelectedBase] = useState(() => {
    // Initialize from localStorage or default to 'rewe.de/shop'
    return localStorage.getItem('selectedBaseUrl') || 'rewe.de/shop';
  });
  
  const baseUrl = baseUrls[selectedBase];
  
  // Save to localStorage whenever selectedBase changes
  useEffect(() => {
    localStorage.setItem('selectedBaseUrl', selectedBase);
  }, [selectedBase]);

  // Prevent search engine indexing
  useEffect(() => {
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow, noarchive, nosnippet';
    document.head.appendChild(metaRobots);

    // Cleanup function to remove the meta tag when component unmounts
    return () => {
      document.head.removeChild(metaRobots);
    };
  }, []);

  // Change browser title
  useEffect(() => {
    const originalTitle = document.title;
    document.title = 'Test URLs';

    // Cleanup function to restore original title when component unmounts
    return () => {
      document.title = originalTitle;
    };
  }, []);
  
  return (
    <div style={{ margin: '20px', lineHeight: '1.6' }}>
      <h1>Test URLs</h1>
      <p>
        <label htmlFor="baseUrl">Base URL: </label>
        <select 
          id="baseUrl"
          value={selectedBase} 
          onChange={(e) => setSelectedBase(e.target.value)}
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          {Object.keys(baseUrls).map(key => (
            <option key={key} value={key}>{baseUrls[key]}</option>
          ))}
        </select>
      </p>
      <p>Click to test:</p>
      {testUrls.map((path, index) => {
        const fullUrl = `${baseUrl}${path}`;
        return (
          <p key={index}>
            <a href={fullUrl}>{fullUrl}</a>
          </p>
        );
      })}
    </div>
  );
};

export default TestUrls;
